import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/runs/{id} — прогон со списком не заехавших строк.
const getStockImportRun = (id) => {
  return api.get(`/api/crm/cars/stockImport/runs/${id}`);
};

export default getStockImportRun;
